var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUniversidade = function SvgUniversidade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#DBF6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5015 31.1019C22.5015 30.0505 23.1702 29.117 24.1617 28.7845L37.1447 24.4307C37.8631 24.1898 38.6398 24.1898 39.3583 24.4307L51.6083 28.5387C53.0375 29.018 54.0015 30.3636 54.0015 31.8792V48.7077L57.0925 52.2817C57.815 53.1539 57.5401 54.4758 56.5308 54.9835L56.1156 55.1924C55.3866 55.5591 54.4521 55.75 53.6371 55.75H52.6158C51.8008 55.75 50.9969 55.5591 50.268 55.1924L49.8528 54.9835C48.8434 54.4758 48.5685 53.1539 49.291 52.2817L52.2515 48.7077V33.4493L39.3583 37.773C38.6398 38.0139 37.8631 38.0139 37.1447 37.773L24.1617 33.4192C23.1702 33.0867 22.5015 32.1533 22.5015 31.1019Z",
    fill: "#36A094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0015 36.5L37.2021 40.0202C37.8852 40.2349 38.6177 40.2349 39.3009 40.0202L50.5015 36.5V45.0167C50.5015 45.0167 48.4598 48.75 38.2515 48.75C28.0431 48.75 26.0015 45.0167 26.0015 45.0167V36.5Z",
    fill: "#36A094"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUniversidade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/universidade.a1ce3dd7.svg";
export { ForwardRef as ReactComponent };